"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Variants = /** @class */ (function () {
    function Variants() {
    }
    return Variants;
}());
exports.Variants = Variants;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Fulfilled"] = "fulfilled";
    OrderStatus["ReadyToMake"] = "ready_to_make";
    OrderStatus["Packing"] = "packing";
    OrderStatus["FailedToCreateInPms"] = "failed_to_create_in_pms";
    OrderStatus["FailedToCreateIn3PL"] = "failed_to_create_in_3pl";
    OrderStatus["FailedToUpdateInPms"] = "failed_to_update_in_pms";
    OrderStatus["WrongPostCode"] = "wrong_post_code";
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Pending"] = "pending";
    OrderStatus["PaymentPending"] = "payment_pending";
    OrderStatus["VMSAwaitingReturn"] = "vms_awaiting_return";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderStatusNames;
(function (OrderStatusNames) {
    OrderStatusNames["fulfilled"] = "Fulfilled";
    OrderStatusNames["ready_to_make"] = "Ready to make";
    OrderStatusNames["packing"] = "Packing";
    OrderStatusNames["failed_to_create_in_pms"] = "Failed to create in PMS";
    OrderStatusNames["failed_to_create_in_3pl"] = "Failed to create in 3PL";
    OrderStatusNames["failed_to_update_in_pms"] = "Failed to update in PMS";
    OrderStatusNames["wrong_post_code"] = "Wrong post code";
    OrderStatusNames["cancelled"] = "Cancelled";
    OrderStatusNames["pending"] = "Pending";
    OrderStatusNames["paymentPending"] = "Payment pending";
    OrderStatusNames["vms_awaiting_return"] = "Vaginal Microbiome Screen awaiting return";
    OrderStatusNames["payment_pending"] = "Payment pending";
})(OrderStatusNames = exports.OrderStatusNames || (exports.OrderStatusNames = {}));
var PurchaseItemType;
(function (PurchaseItemType) {
    PurchaseItemType["OneOffPurchase"] = "one_off_purchase";
    PurchaseItemType["SingleMonthSubscription"] = "subscription";
    PurchaseItemType["MultiMonthSubscription"] = "multi_month_subscription";
    PurchaseItemType["SubscriptionWithCredits"] = "subscription_with_credits";
    PurchaseItemType["OneOffPurchaseWithCredits"] = "one_off_purchase_with_credits";
    PurchaseItemType["B2B"] = "b2b";
    PurchaseItemType["Retail"] = "retail";
    PurchaseItemType["Consultation"] = "consultation";
})(PurchaseItemType = exports.PurchaseItemType || (exports.PurchaseItemType = {}));
var SubscriptionService;
(function (SubscriptionService) {
    SubscriptionService["Recurly"] = "recurly";
    SubscriptionService["PayPal"] = "paypal";
    SubscriptionService["Flex"] = "flex";
})(SubscriptionService = exports.SubscriptionService || (exports.SubscriptionService = {}));
/**
 * Enum representing the types of payment methods available.
 * Used to denote in an OrderCreateRequest which payment type is being used.
 */
var PaymentType;
(function (PaymentType) {
    PaymentType["Card"] = "card";
    PaymentType["PayPal"] = "paypal";
    PaymentType["ApplePay"] = "applepay";
    PaymentType["GooglePay"] = "googlepay";
    PaymentType["Flex"] = "flex";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var ProductCode;
(function (ProductCode) {
    ProductCode["tampon_box"] = "Tampon Box";
    ProductCode["pads_box"] = "Pads Box";
    ProductCode["proviotics"] = "ProViotics";
    ProductCode["mask_pink"] = "Mask (Gold Pink)";
    ProductCode["mask_blue"] = "Mask (Navy Sage)";
    ProductCode["mask_light"] = "Mask (Cream Pink)";
    ProductCode["mask_dark"] = "Mask (Lilac Forest)";
    ProductCode["cbdsuper"] = "CBD Super";
    ProductCode["cbdregular"] = "CBD Regular";
    ProductCode["cbdsuper10"] = "CBD Super";
    ProductCode["cbdregular10"] = "CBD Regular";
    ProductCode["cbdsuper20"] = "CBD Super";
    ProductCode["cbdregular20"] = "CBD Regular";
    ProductCode["cbdsuper30"] = "CBD Super";
    ProductCode["cbdregular30"] = "CBD Regular";
    ProductCode["nakedsuper"] = "Nude Super";
    ProductCode["nakedregular"] = "Nude Regular";
    ProductCode["initiationbox"] = "Initation Box";
    ProductCode["initiationbox_case"] = "Initiaton Box (with case)";
    ProductCode["refillbox"] = "Refill Box (Multi-Month)";
    ProductCode["pr"] = "Regular Pads";
    ProductCode["pn"] = "Super Pads";
    ProductCode["pnp"] = "Super+ Pads";
    ProductCode["pl"] = "Bamboo Liners";
    // New pads
    ProductCode["pad_regular"] = "Regular Pads";
    ProductCode["pad_super"] = "Super Pads";
    ProductCode["pad_super_plus"] = "Super+ Pads";
    ProductCode["cbd_balm"] = "Body Balm";
    ProductCode["blm_pin"] = "BLM Pin";
    ProductCode["gaf_box"] = "Gift A Friend Box";
    ProductCode["squish_box"] = "Squish Box";
    ProductCode["sampler"] = "Sampler";
    ProductCode["holiday_sampler"] = "Holiday Sampler";
    ProductCode["vagina_matters_book"] = "Vagina Matters Book";
    ProductCode["gift_card"] = "Gift Card";
    ProductCode["us_waitlist_prepaid_12"] = "US Waitlist Prepaid Box (12)";
    ProductCode["us_waitlist_prepaid_18"] = "US Waitlist Prepaid Box (18)";
    ProductCode["tin_case"] = "Tampon Case";
    ProductCode["tampon_pouch"] = "Tampon Pouch";
    ProductCode["screening_kit"] = "Diagnostic Tampon Kit";
    ProductCode["vms_essential"] = "Diagnostic Tampon Kit";
    ProductCode["vms_essential_consultation_basic"] = "Diagnostic Tampon With Nurse Consultation";
    ProductCode["vms_advanced"] = "Advanced Vaginal Health Screening";
    ProductCode["vms_premium"] = "HPV + STI + Microbiome Screen";
    ProductCode["hpv_screening"] = "HPV Screen";
    ProductCode["hpv_advanced"] = "HPV + Microbiome Screen";
    ProductCode["sti_screening"] = "STI Screening";
    ProductCode["vms_advanced_sti_4"] = "Advanced Vaginal Health Screening";
    ProductCode["sti_4_screening"] = "STI Screening";
    ProductCode["vms_essential_replacement"] = "Diagnostic Tampon Kit Replacement";
    ProductCode["vms_medication_fee"] = "Vaginal Microbiome Screen Medication Fee";
    ProductCode["vms_prescription_fee"] = "Vaginal Microbiome Screen Prescription Fee";
    ProductCode["sti_medication_fee"] = "Prescriber review fee";
    ProductCode["sti_prescription_fee"] = "Prescriber review fee";
    ProductCode["rose_candle"] = "Rose Candle";
    ProductCode["ppc_standard"] = "Period Pain Clinic - Standard";
    ProductCode["ppc_advanced"] = "Period Pain Clinic - Advanced";
    ProductCode["ppc_premium"] = "Period Pain Clinic - Premium";
    ProductCode["ppc_tampon_box"] = "Prescription CBD Tampons";
    ProductCode["zidoval_gel"] = "Zidoval gel 0.75% (Metronidazole) 40g";
    ProductCode["tampon_box_bundle_regular_flow_mm"] = "3 Month Regular Flow Bundle";
    ProductCode["tampon_box_bundle_regular_flow"] = "Regular Flow Bundle";
    ProductCode["tampon_box_bundle_heavy_flow_mm"] = "3 Month Heavy Flow Bundle";
    ProductCode["tampon_box_bundle_heavy_flow"] = "Heavy Flow Bundle";
    ProductCode["tampon_box_retail_bundle_regular_flow_mm"] = "3 Month Regular Flow Bundle";
    ProductCode["tampon_box_retail_bundle_regular_flow"] = "Regular Flow Bundle";
    ProductCode["tampon_box_retail_bundle_heavy_flow_mm"] = "3 Month Heavy Flow Bundle";
    ProductCode["tampon_box_retail_bundle_heavy_flow"] = "Heavy Flow Bundle";
    ProductCode["tampon_box_bundle_cbd"] = "CBD Bundle";
    ProductCode["tampon_box_bundle_all_in_one_mm"] = "3 Month Period Care Bundle";
    ProductCode["tampon_box_bundle_all_in_one"] = "Period Care Bundle";
    ProductCode["tampon_box_9nr9ns"] = "9 Nude Regular and 9 Nude Super Tampons";
    ProductCode["tampon_box_9cs9ns"] = "9 Coated Super and 9 Nude Super Tampons";
    ProductCode["tampon_box_9cr9nr"] = "9 Coated Regular and 9 Nude Regular Tampons";
    ProductCode["tampon_box_9cr9cs9nr9ns"] = "3 Month Trial Tampon Box";
    ProductCode["tampon_box_9cr9cs"] = "9 Coated Regular and 9 Coated Super Tampons";
    ProductCode["tampon_box_4cr5cs5nr4ns"] = "Organic Tampons Trial Box";
    ProductCode["tampon_box_36ns"] = "36 Nude Super Tampons";
    ProductCode["tampon_box_36nr"] = "36 Nude Regular Tampons";
    ProductCode["tampon_box_36cs"] = "36 Coated Super Tampons";
    ProductCode["tampon_box_36cr"] = "36 Coated Regular Tampons";
    ProductCode["tampon_box_18ns"] = "18 Nude Super Tampons";
    ProductCode["tampon_box_18nr18ns"] = "18 Nude Regular and 18 Nude Super Tampons";
    ProductCode["tampon_box_18nr"] = "18 Nude Regular Tampons";
    ProductCode["tampon_box_18cs18ns"] = "18 Coated Super and 18 Nude Super Tampons";
    ProductCode["tampon_box_18cs"] = "18 Coated Super Tampons";
    ProductCode["tampon_box_18cr18nr"] = "18 Coated Regular and 18 Nude Regular Tampons";
    ProductCode["tampon_box_18cr18cs"] = "18 Coated Regular and 18 Coated Super Tampons";
    ProductCode["tampon_box_18cr"] = "18 Coated Regular Tampons";
    ProductCode["relactagel"] = "Relactagel 2%";
    ProductCode["proviotics_vaginal_health"] = "Vaginal Health Bundle";
    ProductCode["proviotics_mm"] = "ProViotic - 90 tablets";
    ProductCode["pads_box_8r8s3sp12l"] = "Bamboo Pads & Liners Trial Box";
    ProductCode["pads_box_48l"] = "48 Liners";
    ProductCode["pads_box_40s"] = "40 Super Pads";
    ProductCode["pads_box_40r"] = "40 Regular Pads";
    ProductCode["pads_box_32sp"] = "32 Super Plus Pads";
    ProductCode["pads_box_24l"] = "24 Liners";
    ProductCode["pads_box_12l"] = "12 Liners";
    ProductCode["pads_box_20s"] = "20 Super Pads";
    ProductCode["pads_box_20r20s"] = "20 Regular and 20 Super Pads";
    ProductCode["pads_box_20r"] = "20 Regular Pads";
    ProductCode["pads_box_16sp"] = "16 Super Plus Pads";
    ProductCode["pads_box_16r16s6sp24l"] = "3 Month Bamboo Pads & Liners Trial Box";
    ProductCode["pads_box_10r10s"] = "10 Regular and 10 Super Pads";
    ProductCode["pads_box_12_regular"] = "12 Regular Pads";
    ProductCode["pads_box_12_super"] = "12 Super Pads";
    ProductCode["pads_box_10_super_plus"] = "10 Super Plus Pads";
    ProductCode["fluconazole_150mg"] = "Fluconazole 150mg";
    ProductCode["flagyl_500mg"] = "Flagyl\u00AE 500mg (Metronidazole) tablets";
    ProductCode["clotrimazole_cream_50g"] = "Clotrimazole Cream 1% 50g";
    ProductCode["clotrimazole_cream_29g"] = "Clotrimazole Cream 1% 29g";
    ProductCode["clotrimazole_cream_21g"] = "Clotrimazole Cream 2% 21g";
    ProductCode["clotrimazole_cream_20g"] = "Clotrimazole Cream 1% 20g";
    ProductCode["clotrimazole_cream_15g"] = "Clotrimazole Cream 1% 15g";
    ProductCode["clotrimazole_500mg"] = "Clotrimazole 500mg";
    ProductCode["cleocin_40g"] = "Cleocin\u00AE 2% (Clindamycin) 40g";
    ProductCode["boric_acid_capsules"] = "Boric acid capsules";
    ProductCode["consultation_sexual_health"] = "Nurse consultation - 30-minute consultation with a sexual health nurse";
    ProductCode["consultation_fertility"] = "Fertility consultation - 30-minute consultation with a fertility specialist";
    ProductCode["consultation_nutritionist"] = "Nutritionist consultation - 45-minute consultation with a nutritional therapist";
    ProductCode["consultation_general_practitioner"] = "GP consultation - 15-minute consultation with a GP";
    ProductCode["consultation_pelvic_floor_therapist"] = "Pelvic floor therapist consultation - 45-minute consultation with a pelvic floor specialist";
    ProductCode["valentines_sampler"] = "Valentine's Sampler with scrunchie";
    ProductCode["valentines_box"] = "Valentine's Box";
    // items that were present in oms-frontend ProductVariant but missing in ProductCodeKey
    ProductCode["stitest"] = "STI Testing Kit";
    ProductCode["mask"] = "Mask";
    ProductCode["pib"] = "ProViotics Initiation Box";
    ProductCode["sub"] = "Substitute Box";
    ProductCode["scrunchie"] = "Scrunchie";
    ProductCode["gaf"] = "GAF Sample Box";
    ProductCode["ndtmo1"] = "NDT Month 1";
    ProductCode["ndtmo2"] = "NDT Month 2";
    ProductCode["ndtmo3"] = "NDT Month 3";
    ProductCode["ndtmo4"] = "NDT Month 4";
    ProductCode["mask_ndt"] = "Mask (NDT)";
    ProductCode["festive_bundle"] = "Festive Bundle";
    ProductCode["custom_order"] = "Custom Order";
})(ProductCode = exports.ProductCode || (exports.ProductCode = {}));
var ProductCodeKey;
(function (ProductCodeKey) {
    ProductCodeKey["TamponBox"] = "tampon_box";
    ProductCodeKey["Pads"] = "pads_box";
    ProductCodeKey["Proviotics"] = "proviotics";
    ProductCodeKey["CbdBalm"] = "cbd_balm";
    ProductCodeKey["Sampler"] = "sampler";
    ProductCodeKey["HolidaySampler"] = "holiday_sampler";
    ProductCodeKey["SquishBox"] = "squish_box";
    ProductCodeKey["MaskPink"] = "mask_pink";
    ProductCodeKey["MaskBlue"] = "mask_blue";
    ProductCodeKey["MaskLight"] = "mask_light";
    ProductCodeKey["MaskDark"] = "mask_dark";
    ProductCodeKey["VaginaMattersBook"] = "vagina_matters_book";
    ProductCodeKey["GiftCard"] = "gift_card";
    ProductCodeKey["BlmPin"] = "blm_pin";
    ProductCodeKey["USWaitlistPrepaid12"] = "us_waitlist_prepaid_12";
    ProductCodeKey["USWaitlistPrepaid18"] = "us_waitlist_prepaid_18";
    ProductCodeKey["ValentinesSampler"] = "valentines_sampler";
    ProductCodeKey["ValentinesBox"] = "valentines_box";
    ProductCodeKey["TamponPouch"] = "tampon_pouch";
    ProductCodeKey["TamponTin"] = "tin_case";
    ProductCodeKey["ScreeningKit"] = "screening_kit";
    ProductCodeKey["VMSEssential"] = "vms_essential";
    ProductCodeKey["VMSAdvanced"] = "vms_advanced";
    ProductCodeKey["HPVScreening"] = "hpv_screening";
    ProductCodeKey["HPVAdvanced"] = "hpv_advanced";
    ProductCodeKey["VMSPremium"] = "vms_premium";
    ProductCodeKey["STIScreening"] = "sti_screening";
    ProductCodeKey["VMSAdvanced4STI"] = "vms_advanced_sti_4";
    ProductCodeKey["STI4Screening"] = "sti_4_screening";
    ProductCodeKey["VMSEssentialReplacement"] = "vms_essential_replacement";
    ProductCodeKey["VMSMedicationFee"] = "vms_medication_fee";
    ProductCodeKey["VMSPrescriptionFee"] = "vms_prescription_fee";
    ProductCodeKey["STIMedicationFee"] = "sti_medication_fee";
    ProductCodeKey["STIPrescriptionFee"] = "sti_prescription_fee";
    ProductCodeKey["VMSEssentialWithBasicConsultation"] = "vms_essential_consultation_basic";
    ProductCodeKey["VaginalHealthBundle"] = "proviotics_vaginal_health";
    ProductCodeKey["PPCTamponBox"] = "ppc_tampon_box";
    ProductCodeKey["PPCStandard"] = "ppc_standard";
    ProductCodeKey["PPCAdvanced"] = "ppc_advanced";
    ProductCodeKey["PPCPremium"] = "ppc_premium";
    ProductCodeKey["RoseCandle"] = "rose_candle";
    ProductCodeKey["FestiveBundle"] = "festive_bundle";
    // new hemp pads in a box
    ProductCodeKey["PadsRegular12"] = "pads_box_12_regular";
    ProductCodeKey["PadsSuper12"] = "pads_box_12_super";
    ProductCodeKey["PadsSuperPlus10"] = "pads_box_10_super_plus";
    ProductCodeKey["PadsLiners24"] = "pads_box_24l";
    // old bamboo pads single configuration
    ProductCodeKey["RegularPad"] = "pr";
    ProductCodeKey["SuperPad"] = "pn";
    ProductCodeKey["SuperPadPlus"] = "pnp";
    ProductCodeKey["LinerPad"] = "pl";
    // tampons
    ProductCodeKey["CBDRegular"] = "cbdregular";
    ProductCodeKey["CBDSuper"] = "cbdsuper";
    ProductCodeKey["NakedRegular"] = "nakedregular";
    ProductCodeKey["NakedSuper"] = "nakedsuper";
    ProductCodeKey["TamponInitiationBox"] = "initiationbox";
    ProductCodeKey["TamponInitiationBoxCase"] = "initiationbox_case";
    ProductCodeKey["TamponBoxBundleRegularFlowMm"] = "tampon_box_bundle_regular_flow_mm";
    ProductCodeKey["TamponBoxBundleRegularFlow"] = "tampon_box_bundle_regular_flow";
    ProductCodeKey["TamponBoxBundleHeavyFlowMm"] = "tampon_box_bundle_heavy_flow_mm";
    ProductCodeKey["TamponBoxBundleHeavyFlow"] = "tampon_box_bundle_heavy_flow";
    // New retail bundles
    ProductCodeKey["TamponRetailBoxBundleHeavyFlow"] = "tampon_box_retail_bundle_heavy_flow";
    ProductCodeKey["TamponRetailBoxBundleRegularFlow"] = "tampon_box_retail_bundle_regular_flow";
    ProductCodeKey["TamponRetailBoxBundleHeavyFlowMm"] = "tampon_box_retail_bundle_heavy_flow_mm";
    ProductCodeKey["TamponRetailBoxBundleRegularFlowMm"] = "tampon_box_retail_bundle_regular_flow_mm";
    ProductCodeKey["CustomOrder"] = "custom_order";
})(ProductCodeKey = exports.ProductCodeKey || (exports.ProductCodeKey = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["GB"] = "GB";
    CountryCode["DE"] = "DE";
    CountryCode["NL"] = "NL";
    CountryCode["IE"] = "IE";
    CountryCode["BE"] = "BE";
    CountryCode["IT"] = "IT";
    CountryCode["ES"] = "ES";
    CountryCode["PT"] = "PT";
    CountryCode["BG"] = "BG";
    CountryCode["FR"] = "FR";
    CountryCode["US"] = "US";
    CountryCode["SE"] = "SE";
    CountryCode["DK"] = "DK";
    CountryCode["NO"] = "NO";
    CountryCode["FI"] = "FI";
    CountryCode["AT"] = "AT";
    CountryCode["CH"] = "CH";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var CountryName;
(function (CountryName) {
    CountryName["GB"] = "United Kingdom";
    CountryName["NL"] = "Netherlands";
    CountryName["IE"] = "Ireland";
    CountryName["BE"] = "Belgium";
    CountryName["IT"] = "Italy";
    CountryName["ES"] = "Spain";
    CountryName["PT"] = "Portugal";
    CountryName["BG"] = "Bulgaria";
    CountryName["DE"] = "Germany";
    CountryName["FR"] = "France";
    CountryName["US"] = "United States";
    CountryName["SE"] = "Sweden";
    CountryName["DK"] = "Denmark";
    CountryName["NO"] = "Norway";
    CountryName["FI"] = "Finland";
    CountryName["AT"] = "Austria";
    CountryName["CH"] = "Switzerland";
})(CountryName = exports.CountryName || (exports.CountryName = {}));
var CountryFlagForCode;
(function (CountryFlagForCode) {
    CountryFlagForCode["NL"] = "\uD83C\uDDF3\uD83C\uDDF1";
    CountryFlagForCode["GB"] = "\uD83C\uDDEC\uD83C\uDDE7";
    CountryFlagForCode["EN"] = "\uD83C\uDDEC\uD83C\uDDE7";
    CountryFlagForCode["IE"] = "\uD83C\uDDEE\uD83C\uDDEA";
    CountryFlagForCode["BE"] = "\uD83C\uDDE7\uD83C\uDDEA";
    CountryFlagForCode["IT"] = "\uD83C\uDDEE\uD83C\uDDF9";
    CountryFlagForCode["DE"] = "\uD83C\uDDE9\uD83C\uDDEA";
    CountryFlagForCode["ES"] = "\uD83C\uDDEA\uD83C\uDDF8";
    CountryFlagForCode["PT"] = "\uD83C\uDDF5\uD83C\uDDF9";
    CountryFlagForCode["BG"] = "\uD83C\uDDE7\uD83C\uDDEC";
    CountryFlagForCode["FR"] = "\uD83C\uDDEB\uD83C\uDDF7";
    CountryFlagForCode["US"] = "\uD83C\uDDFA\uD83C\uDDF8";
    CountryFlagForCode["SE"] = "\uD83C\uDDF8\uD83C\uDDEA";
    CountryFlagForCode["DK"] = "\uD83C\uDDE9\uD83C\uDDF0";
    CountryFlagForCode["NO"] = "\uD83C\uDDF3\uD83C\uDDF4";
    CountryFlagForCode["FI"] = "\uD83C\uDDEB\uD83C\uDDEE";
    CountryFlagForCode["AT"] = "\uD83C\uDDE6\uD83C\uDDF9";
    CountryFlagForCode["CH"] = "\uD83C\uDDE8\uD83C\uDDED";
})(CountryFlagForCode = exports.CountryFlagForCode || (exports.CountryFlagForCode = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["Days"] = "days";
    IntervalUnit["Months"] = "months";
})(IntervalUnit = exports.IntervalUnit || (exports.IntervalUnit = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Tampons"] = "tampons";
    SubscriptionType["Proviotics"] = "proviotics";
    SubscriptionType["VMS"] = "vms";
    SubscriptionType["Pads"] = "pads";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
var SubscriptionPlanCode;
(function (SubscriptionPlanCode) {
    SubscriptionPlanCode["Tampons1Month"] = "tampon_1_month";
    SubscriptionPlanCode["Tampons3Month"] = "tampon_3_month";
    SubscriptionPlanCode["Tampons6Month"] = "tampon_6_month";
    SubscriptionPlanCode["Tampons6MonthUpfront"] = "tampon_6_month_upfront";
    SubscriptionPlanCode["Tampons12Month"] = "tampon_12_month";
    SubscriptionPlanCode["Tampons12MonthUpfront"] = "tampon_12_month_upfront";
    SubscriptionPlanCode["Proviotics1Month"] = "proviotics_1_month";
    SubscriptionPlanCode["Proviotics3Month"] = "proviotics_3_month";
    SubscriptionPlanCode["Proviotics6Month"] = "proviotics_6_month";
    SubscriptionPlanCode["Proviotics6MonthUpfront"] = "proviotics_6_month_upfront";
    SubscriptionPlanCode["Proviotics12Month"] = "proviotics_12_month";
    SubscriptionPlanCode["Proviotics12MonthUpfront"] = "proviotics_12_month_upfront";
    SubscriptionPlanCode["ScreeningKit"] = "screening_kit";
    SubscriptionPlanCode["B2B"] = "b2b";
    SubscriptionPlanCode["B2B6Weeks"] = "b2b_6week";
    SubscriptionPlanCode["Retail2Weeks"] = "retail_14";
    SubscriptionPlanCode["Retail4Weeks"] = "retail_28";
    SubscriptionPlanCode["Retail2Months"] = "retail_60";
    SubscriptionPlanCode["Retail3Months"] = "retail_90";
    SubscriptionPlanCode["Pads1Month"] = "pads_1_month";
    SubscriptionPlanCode["Pads3Month"] = "pads_3_month";
    SubscriptionPlanCode["Pads6Month"] = "pads_6_month";
    SubscriptionPlanCode["Pads12Month"] = "pads_12_month";
    SubscriptionPlanCode["PPCTamponBox3Month"] = "ppc_tampon_3_month";
    SubscriptionPlanCode["Company1MonthBasic"] = "company_1_month_basic";
    SubscriptionPlanCode["Company1MonthStandard"] = "company_1_month_standard";
    SubscriptionPlanCode["Company1MonthPlus"] = "company_1_month_plus";
    SubscriptionPlanCode["Company3MonthBasic"] = "company_3_month_basic";
    SubscriptionPlanCode["Company3MonthStandard"] = "company_3_month_standard";
    SubscriptionPlanCode["Company3MonthPlus"] = "company_3_month_plus";
    SubscriptionPlanCode["Company6MonthBasic"] = "company_6_month_basic";
    SubscriptionPlanCode["Company6MonthStandard"] = "company_6_month_standard";
    SubscriptionPlanCode["Company6MonthPlus"] = "company_6_month_plus";
    SubscriptionPlanCode["Company12MonthBasic"] = "company_12_month_basic";
    SubscriptionPlanCode["Company12MonthStandard"] = "company_12_month_standard";
    SubscriptionPlanCode["Company12MonthPlus"] = "company_12_month_plus";
})(SubscriptionPlanCode = exports.SubscriptionPlanCode || (exports.SubscriptionPlanCode = {}));
var SubscriptionChangeTimeframe;
(function (SubscriptionChangeTimeframe) {
    SubscriptionChangeTimeframe["Renewal"] = "renewal";
    SubscriptionChangeTimeframe["BillDate"] = "bill_date";
    SubscriptionChangeTimeframe["Now"] = "now";
})(SubscriptionChangeTimeframe = exports.SubscriptionChangeTimeframe || (exports.SubscriptionChangeTimeframe = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["BGN"] = "BGN";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
var CurrencyCodeForSymbol;
(function (CurrencyCodeForSymbol) {
    CurrencyCodeForSymbol["\u00A3"] = "GBP";
    CurrencyCodeForSymbol["\u20AC"] = "EUR";
    CurrencyCodeForSymbol["$"] = "USD";
    CurrencyCodeForSymbol["\u043B\u0432"] = "BGN";
})(CurrencyCodeForSymbol = exports.CurrencyCodeForSymbol || (exports.CurrencyCodeForSymbol = {}));
var CurrencySymbolForCode;
(function (CurrencySymbolForCode) {
    CurrencySymbolForCode["GBP"] = "\u00A3";
    CurrencySymbolForCode["EUR"] = "\u20AC";
    CurrencySymbolForCode["USD"] = "$";
    CurrencySymbolForCode["BGN"] = "\u043B\u0432";
})(CurrencySymbolForCode = exports.CurrencySymbolForCode || (exports.CurrencySymbolForCode = {}));
var ResultStatus;
(function (ResultStatus) {
    ResultStatus["Pending"] = "pending";
    ResultStatus["Rejected"] = "rejected";
    ResultStatus["AwaitingSampleCollection"] = "awaiting_sample_collection";
    ResultStatus["AwaitingReturn"] = "awaiting_return";
    ResultStatus["AwaitingSample"] = "awaiting_sample";
    ResultStatus["SampleInTransit"] = "sample_in_transit";
    ResultStatus["ReviewPending"] = "review_pending";
    ResultStatus["SampleReceived"] = "sample_received";
    ResultStatus["SampleProcessing"] = "sample_processing";
    ResultStatus["SamplePendingRelease"] = "sample_pending_release";
    ResultStatus["ResultsReturned"] = "results_returned";
    ResultStatus["Expired"] = "expired";
})(ResultStatus = exports.ResultStatus || (exports.ResultStatus = {}));
var ResultType;
(function (ResultType) {
    // Basic types:
    ResultType["VMSEssential"] = "vms_essential";
    ResultType["STIScreening"] = "sti_screening";
    ResultType["HPVScreening"] = "hpv_screening";
    // Advanced Types:
    ResultType["VMSAdvanced"] = "vms_advanced";
    ResultType["HPVAdvanced"] = "hpv_advanced";
    // Premium Types:
    ResultType["VMSPremium"] = "vms_premium";
    // Lab variations:
    ResultType["VMSAdvanced4STI"] = "vms_advanced_sti_4";
    ResultType["STI4Screening"] = "sti_4_screening";
    ResultType["HPVNHS"] = "hpv_nhs";
})(ResultType = exports.ResultType || (exports.ResultType = {}));
var VMSVariationType;
(function (VMSVariationType) {
    VMSVariationType["GelPack"] = "gel_pack";
    VMSVariationType["TransportMedium"] = "transport_medium";
    VMSVariationType["NoMedium"] = "no_medium";
    VMSVariationType["RetailBox"] = "retail_box";
    VMSVariationType["RetailBoxWisp"] = "retail_box_wisp";
    VMSVariationType["D2CBoxWisp"] = "d2c_box_wisp";
    VMSVariationType["NewLifeFertilityClinic"] = "new_life_fertility_clinic";
    VMSVariationType["ClinicBoxNHS"] = "clinic_box_nhs";
    VMSVariationType["D2CBoxIreland"] = "d2c_box_ireland";
    VMSVariationType["D2CBoxGermany"] = "d2c_box_germany";
})(VMSVariationType = exports.VMSVariationType || (exports.VMSVariationType = {}));
var TreatmentStatus;
(function (TreatmentStatus) {
    TreatmentStatus["Pending"] = "pending";
    TreatmentStatus["RequiresAction"] = "requires_action";
    TreatmentStatus["Rejected"] = "rejected";
    TreatmentStatus["Approved"] = "approved";
    TreatmentStatus["WithPharmacy"] = "with_pharmacy";
    TreatmentStatus["Dispatched"] = "dispatched";
})(TreatmentStatus = exports.TreatmentStatus || (exports.TreatmentStatus = {}));
var VMSLaboratory;
(function (VMSLaboratory) {
    VMSLaboratory["SalientBio"] = "salientbio";
    VMSLaboratory["AlderleyLighthouseLabs"] = "alderleylighthouselabs";
    VMSLaboratory["Avrok"] = "avrok";
})(VMSLaboratory = exports.VMSLaboratory || (exports.VMSLaboratory = {}));
var DeliveryServiceProvider;
(function (DeliveryServiceProvider) {
    DeliveryServiceProvider["RoyalMail"] = "RoyalMail";
    DeliveryServiceProvider["USPS"] = "USPS";
})(DeliveryServiceProvider = exports.DeliveryServiceProvider || (exports.DeliveryServiceProvider = {}));
var Pharmacy;
(function (Pharmacy) {
    Pharmacy["Truepill"] = "truepill";
    Pharmacy["Cedarwood"] = "cedarwood";
    Pharmacy["Phlo"] = "phlo";
    Pharmacy["Curexa"] = "curexa";
    Pharmacy["Blueco"] = "blueco";
})(Pharmacy = exports.Pharmacy || (exports.Pharmacy = {}));
var LabRejectionReason;
(function (LabRejectionReason) {
    LabRejectionReason["BloodOnTampon"] = "1: Blood on tampon";
    LabRejectionReason["LongTransitTime"] = "2: Long transit time to lab";
    LabRejectionReason["DamagedPackaging"] = "3: Damaged packaging";
    LabRejectionReason["NotDayeTampon"] = "4: Not Daye tampon";
    LabRejectionReason["ContaminatedTampon"] = "5: Contaminated tampon";
    LabRejectionReason["InconclusiveResult"] = "6: Inconclusive result";
    LabRejectionReason["InconclusiveResultNoErrorCode"] = "Inconclusive result";
})(LabRejectionReason = exports.LabRejectionReason || (exports.LabRejectionReason = {}));
var RxMedicationProductUS;
(function (RxMedicationProductUS) {
    RxMedicationProductUS["fluconazole_150mg"] = "Fluconazole 150mg";
    RxMedicationProductUS["cleocin_40g"] = "Cleocin\u00AE 2% (Clindamycin) 40g";
    RxMedicationProductUS["flagyl_500mg"] = "Flagyl\u00AE (Metronidazole) 500mg";
    RxMedicationProductUS["zidoval_gel"] = "Zidoval gel 0.75% (Metronidazole) 40g";
})(RxMedicationProductUS = exports.RxMedicationProductUS || (exports.RxMedicationProductUS = {}));
var OTCMedicationProductUS;
(function (OTCMedicationProductUS) {
    OTCMedicationProductUS["clotrimazole_cream_29g"] = "Clotrimazole Cream 1% 29g";
    OTCMedicationProductUS["clotrimazole_cream_15g"] = "Clotrimazole Cream 1% 15g";
    OTCMedicationProductUS["clotrimazole_cream_21g"] = "Clotrimazole Cream 2% 21g";
    OTCMedicationProductUS["boric_acid_capsules"] = "Boric acid capsules";
})(OTCMedicationProductUS = exports.OTCMedicationProductUS || (exports.OTCMedicationProductUS = {}));
var RxMedicationProductUK;
(function (RxMedicationProductUK) {
    RxMedicationProductUK["clotrimazole_cream_20g"] = "Clotrimazole Cream 1% 20g";
    RxMedicationProductUK["clotrimazole_cream_50g"] = "Clotrimazole Cream 1% 50g";
    RxMedicationProductUK["clotrimazole_500mg"] = "Clotrimazole 500mg";
    RxMedicationProductUK["fluconazole_150mg"] = "Fluconazole 150mg";
    RxMedicationProductUK["relactagel"] = "Relactagel";
    RxMedicationProductUK["ppc_tampon_box"] = "Period Pain Clinic Tampon Box";
})(RxMedicationProductUK = exports.RxMedicationProductUK || (exports.RxMedicationProductUK = {}));
var STIMedicationProductUK;
(function (STIMedicationProductUK) {
    STIMedicationProductUK["sti_help_me_decide_treatment"] = "Daye STI Treatment (help-me-decide)";
    // Chlamydia
    STIMedicationProductUK["doxycycline_100mg"] = "Doxycycline 100mg (14 doses)";
    STIMedicationProductUK["azithromycin_500mg"] = "Azithromycin 500mg (4 doses)";
    // Mycoplasma genitalium
    STIMedicationProductUK["combined_doxycycline_100mg_azithromycin_500mg"] = "Doxycycline 100mg (14 doses) + Azithromycin 500 mg (4 doses)";
    // Trichomoniasis
    STIMedicationProductUK["metronidazole_400mg"] = "Metronidazole 400mg (14 doses)";
})(STIMedicationProductUK = exports.STIMedicationProductUK || (exports.STIMedicationProductUK = {}));
var RxMedicationProductCodeKey;
(function (RxMedicationProductCodeKey) {
    RxMedicationProductCodeKey["Fluconazole150mg"] = "fluconazole_150mg";
    RxMedicationProductCodeKey["Cleocin40g"] = "cleocin_40g";
    RxMedicationProductCodeKey["Flagyl500mg"] = "flagyl_500mg";
    RxMedicationProductCodeKey["ZidovalGel"] = "zidoval_gel";
    // UK PRODUCTS
    RxMedicationProductCodeKey["ClotrimazoleCream20g"] = "clotrimazole_cream_20g";
    RxMedicationProductCodeKey["ClotrimazoleCream50g"] = "clotrimazole_cream_50g";
    RxMedicationProductCodeKey["Clotrimazole500mg"] = "clotrimazole_500mg";
    RxMedicationProductCodeKey["Relactagel"] = "relactagel";
    RxMedicationProductCodeKey["PPCTamponBox"] = "ppc_tampon_box";
})(RxMedicationProductCodeKey = exports.RxMedicationProductCodeKey || (exports.RxMedicationProductCodeKey = {}));
var OTCMedicationProductCodeKey;
(function (OTCMedicationProductCodeKey) {
    OTCMedicationProductCodeKey["ClotrimazoleCream29g"] = "clotrimazole_cream_29g";
    OTCMedicationProductCodeKey["ClotrimazoleCream15g"] = "clotrimazole_cream_15g";
    OTCMedicationProductCodeKey["ClotrimazoleCream21g"] = "clotrimazole_cream_21g";
    OTCMedicationProductCodeKey["BoricAcidCapsules"] = "boric_acid_capsules";
})(OTCMedicationProductCodeKey = exports.OTCMedicationProductCodeKey || (exports.OTCMedicationProductCodeKey = {}));
var STIMedicationProductCodeKey;
(function (STIMedicationProductCodeKey) {
    STIMedicationProductCodeKey["STIHelpMeDecideTreatment"] = "sti_help_me_decide_treatment";
    STIMedicationProductCodeKey["Doxycycline100mg"] = "doxycycline_100mg";
    STIMedicationProductCodeKey["Azithromycin500mg"] = "azithromycin_500mg";
    STIMedicationProductCodeKey["Metronidazole400mg"] = "metronidazole_400mg";
    STIMedicationProductCodeKey["CombinedDoxycycline100mgAzithromycin500mg"] = "combined_doxycycline_100mg_azithromycin_500mg";
})(STIMedicationProductCodeKey = exports.STIMedicationProductCodeKey || (exports.STIMedicationProductCodeKey = {}));
var DetectionStatus;
(function (DetectionStatus) {
    DetectionStatus["Detected"] = "detected";
    DetectionStatus["NotDetected"] = "not_detected";
    DetectionStatus["Inconclusive"] = "inconclusive";
})(DetectionStatus = exports.DetectionStatus || (exports.DetectionStatus = {}));
var PrescriptionAuthority;
(function (PrescriptionAuthority) {
    PrescriptionAuthority["MDIntegrations"] = "mdi";
    PrescriptionAuthority["Cliniko"] = "cliniko";
})(PrescriptionAuthority = exports.PrescriptionAuthority || (exports.PrescriptionAuthority = {}));
var Consent;
(function (Consent) {
    Consent["YES"] = "yes";
    Consent["NO"] = "no";
})(Consent = exports.Consent || (exports.Consent = {}));
var OrderPackingDepletionReason;
(function (OrderPackingDepletionReason) {
    OrderPackingDepletionReason["Fulfilment"] = "Fulfilment";
    OrderPackingDepletionReason["Production"] = "Production";
    OrderPackingDepletionReason["Scrap"] = "Scrap";
    OrderPackingDepletionReason["Equalizing"] = "Equalizing";
    OrderPackingDepletionReason["ToInitial"] = "ToInitial";
    OrderPackingDepletionReason["StockMove"] = "StockMove";
    OrderPackingDepletionReason["ResearchAndDevelopment"] = "R&D";
    OrderPackingDepletionReason["Samples"] = "Samples";
    OrderPackingDepletionReason["Kitting"] = "Kitting";
})(OrderPackingDepletionReason = exports.OrderPackingDepletionReason || (exports.OrderPackingDepletionReason = {}));
var OrderType;
(function (OrderType) {
    OrderType["D2C"] = "D2C";
    OrderType["B2B"] = "B2B";
    OrderType["Retailer"] = "Retailer";
    OrderType["RnD"] = "R&D";
    OrderType["CX_Marketing"] = "CX/Marketing";
    OrderType["Replacements_MissingItems"] = "Replacements/MissingItems";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var PackingProvider;
(function (PackingProvider) {
    PackingProvider["Daye"] = "daye";
    PackingProvider["Fusion"] = "fusion";
    PackingProvider["XPDEL"] = "xpdel";
})(PackingProvider = exports.PackingProvider || (exports.PackingProvider = {}));
/**
 * Represents the effectiveness of a resource based on customer feedback.
 * @enum {string}
 */
var ResourceEffectiveness;
(function (ResourceEffectiveness) {
    /** No feedback has been provided */
    ResourceEffectiveness["NotInterested"] = "Not interested";
    /** Customer showed interest in providing feedback but didn't select an option */
    ResourceEffectiveness["Interested"] = "Interested";
    /** Resource was found to be not effective */
    ResourceEffectiveness["NotEffective"] = "Not effective";
    /** Resource was found to be somewhat effective */
    ResourceEffectiveness["SomewhatEffective"] = "Somewhat effective";
    /** Resource was found to be very effective */
    ResourceEffectiveness["VeryEffective"] = "Very effective";
})(ResourceEffectiveness = exports.ResourceEffectiveness || (exports.ResourceEffectiveness = {}));
var ShippingProvider;
(function (ShippingProvider) {
    ShippingProvider["RoyalMail"] = "royal-mail";
    ShippingProvider["Whistl"] = "whistl";
    ShippingProvider["PostOne"] = "post-one";
    ShippingProvider["DHL"] = "dhl";
    ShippingProvider["Default"] = "default";
})(ShippingProvider = exports.ShippingProvider || (exports.ShippingProvider = {}));
